import "./GetInTouch.module.css";
import Header from "@/reusable_sections/Header";
import LetSCreateMagic from "./sections/LetSCreateMagic";
import StudioLocation from "./sections/StudioLocation";
import Footer from "@/reusable_sections/Footer";
export default function GetInTouchPage() {
  return <div>
      <Header />
      <LetSCreateMagic />
      <StudioLocation />
      <Footer />
    </div>;
}